import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { EnvironmentService } from '../../../../../../common/services/env-configuration/environment.service';
import { environment } from '../../../../../../../environments/environment';
import { ImageUtils } from '../../../../../../common/utils/image-utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-form-field-image-uploader',
  templateUrl: './image-uploader-form-field.component.html',
  styleUrls: ['./image-uploader-form-field.component.scss'],
  standalone: false,
})
export class ImageUploaderFormFieldComponent extends DataTypeComponent implements OnDestroy, AfterViewInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: string;

  @Input() editMode: boolean;

  imageSrc: string;

  showLargeImage = false;

  dragging = false;

  loaded = false;

  loadedImage = false;

  activeColor = 'green';

  baseColor = '#ccc';

  overlayColor = 'red';

  constructor(
    private environmentService: EnvironmentService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewInit() {
    if (this.data !== undefined) {
      if (typeof this.data === 'string') {
        if (this.data.startsWith('data:image')) {
          this.imageSrc = this.data;
        } else if (this.data.indexOf('./assets/') >= 0) {
          this.imageSrc = ImageUtils.relocateImage(this.data);
        }
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  ngOnDestroy() {}

  onDropHandler(object) {
    this.imageSrc = object.event.target.result;
  }

  handleDragEnter() {
    this.dragging = true;
    this.changeDetectorRef.detectChanges();
  }

  handleDragLeave() {
    this.dragging = false;
    this.changeDetectorRef.detectChanges();
  }

  handleDrop(e) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
    this.changeDetectorRef.detectChanges();
  }

  handleImageLoad() {
    this.data = this.imageSrc;
    this.loadedImage = true;
    this.changeDetectorRef.detectChanges();
    this.formGroup.get(this.fieldConfig.name).setValue(this.imageSrc, { emitEvent: false });
  }

  handleInputChange(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    const pattern = /image-*/;
    const reader = new FileReader();

    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    this.loaded = false;

    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    const reader = e.target;
    this.imageSrc = reader.result;
    this.loaded = true;
    this.changeDetectorRef.detectChanges();
  }

  showOriginal() {
    this.showLargeImage = true;
  }

  onClose() {
    this.showLargeImage = false;
  }
}
